import { getEnv } from '@suite/shared';

export const environment = {
  production: true,
  get errorLevel() {
    return getEnv('env') === 'dev' ? 'warn' : 'none';
  },
  showHoodColors: getEnv('env') !== 'prod',
};
